import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { IconBadge } from '../IconBadge/IconBadge.js';
import '../Icon/generated/IconAdd.js';
import '../Icon/generated/IconAddFilled.js';
import '../Icon/generated/IconAddOutline.js';
import '../Icon/generated/IconAddUser.js';
import '../Icon/generated/IconAddressBook.js';
import '../Icon/generated/IconAllTreatments.js';
import '../Icon/generated/IconArrowBack.js';
import '../Icon/generated/IconArrowForward.js';
import '../Icon/generated/IconBadgeCheck.js';
import '../Icon/generated/IconBeard.js';
import '../Icon/generated/IconBody.js';
import '../Icon/generated/IconCake.js';
import '../Icon/generated/IconCalendar.js';
import '../Icon/generated/IconCalendarAdd.js';
import '../Icon/generated/IconCalendarDelete.js';
import '../Icon/generated/IconCard.js';
import '../Icon/generated/IconCash.js';
import '../Icon/generated/IconCaution.js';
import '../Icon/generated/IconChat.js';
import '../Icon/generated/IconCheckFilled.js';
import '../Icon/generated/IconCheckOutline.js';
import '../Icon/generated/IconChecked.js';
import '../Icon/generated/IconChevronDown.js';
import '../Icon/generated/IconChevronLeft.js';
import '../Icon/generated/IconChevronLeftOutline.js';
import '../Icon/generated/IconChevronRight.js';
import '../Icon/generated/IconChevronRightOutline.js';
import '../Icon/generated/IconChevronUp.js';
import '../Icon/generated/IconClose.js';
import '../Icon/generated/IconCloseOutline.js';
import '../Icon/generated/IconComment.js';
import '../Icon/generated/IconCompass.js';
import '../Icon/generated/IconConfirmOrDeny.js';
import '../Icon/generated/IconCopy.js';
import '../Icon/generated/IconDiscountFilled.js';
import '../Icon/generated/IconDiscountOutline.js';
import '../Icon/generated/IconEdit.js';
import '../Icon/generated/IconEmail.js';
import '../Icon/generated/IconExpand.js';
import '../Icon/generated/IconExternal.js';
import '../Icon/generated/IconFace.js';
import '../Icon/generated/IconFilter.js';
import '../Icon/generated/IconGift.js';
import '../Icon/generated/IconHair.js';
import '../Icon/generated/IconHairRemoval.js';
import '../Icon/generated/IconHappy.js';
import '../Icon/generated/IconHeartFilled.js';
import '../Icon/generated/IconHeartOutlined.js';
import '../Icon/generated/IconHelp.js';
import '../Icon/generated/IconHide.js';
import '../Icon/generated/IconHighlights.js';
import '../Icon/generated/IconHome.js';
import '../Icon/generated/IconHomebasedVenue.js';
import '../Icon/generated/IconImage.js';
import '../Icon/generated/IconInfoOutline.js';
import '../Icon/generated/IconLegal.js';
import '../Icon/generated/IconLocation.js';
import '../Icon/generated/IconLock.js';
import '../Icon/generated/IconLogOut.js';
import '../Icon/generated/IconMale.js';
import '../Icon/generated/IconMassage.js';
import '../Icon/generated/IconMedicalDental.js';
import '../Icon/generated/IconMinusOutline.js';
import '../Icon/generated/IconMobileVenue.js';
import '../Icon/generated/IconMoney.js';
import '../Icon/generated/IconNails.js';
import '../Icon/generated/IconNewVenue.js';
import '../Icon/generated/IconNotes.js';
import '../Icon/generated/IconOnMap.js';
import '../Icon/generated/IconOptions.js';
import '../Icon/generated/IconPhone.js';
import '../Icon/generated/IconPin.js';
import '../Icon/generated/IconPinOutline.js';
import '../Icon/generated/IconPresentBox.js';
import '../Icon/generated/IconProfile.js';
import '../Icon/generated/IconReceipt.js';
import '../Icon/generated/IconSearch.js';
import '../Icon/generated/IconSecure.js';
import '../Icon/generated/IconSettings.js';
import '../Icon/generated/IconSort.js';
import '../Icon/generated/IconSpa.js';
import '../Icon/generated/IconStarFilled.js';
import '../Icon/generated/IconStarOutline.js';
import '../Icon/generated/IconSupport.js';
import { IconTeam } from '../Icon/generated/IconTeam.js';
import '../Icon/generated/IconTime.js';
import '../Icon/generated/IconTreatwellLogo.js';
import '../Icon/generated/IconUnisex.js';
import { IconUser } from '../Icon/generated/IconUser.js';
import '../Icon/generated/IconUserDetails.js';
import '../Icon/generated/IconVenue.js';
import '../Icon/generated/IconView.js';
import '../Icon/generated/IconVoucher.js';
import '../Icon/generated/IconWallet.js';
import '../Icon/generated/IconWarningFilled.js';
import '../Icon/generated/IconWarningOutline.js';
import '../Icon/generated/IconWebsite.js';
import { Badge } from '../../Internal/Badge/Badge.js';
import { ColorPairTeal } from '../../Internal/Badge/colour-pair.js';
import styles from './EmployeeBadge.module.css.js';
import { Text } from '../Text/Text.js';

const EmployeeBadge = ({ colorPair = ColorPairTeal, size = 'lg', employee, }) => {
    if (typeof employee === 'object') {
        if (employee.thumbnailUrl !== undefined) {
            return (jsxRuntimeExports.jsx(Badge, { colorPair: colorPair, size: size, children: jsxRuntimeExports.jsx("img", { className: styles.thumbnail, src: employee.thumbnailUrl }) }));
        }
        else {
            const employeeInitial = employee.name.charAt(0).toUpperCase();
            const textType = size === 'sm' ? 'bodyHeavy' : 'mdHeader';
            return (jsxRuntimeExports.jsx(Badge, { colorPair: colorPair, size: size, children: jsxRuntimeExports.jsx(Text, { as: "div", type: textType, children: employeeInitial }) }));
        }
    }
    const iconSize = size === 'sm' ? 16 : 24;
    const Icon = employee === 'multiple' ? IconTeam : IconUser;
    return (jsxRuntimeExports.jsx(IconBadge, { colorPair: colorPair, size: size, icon: jsxRuntimeExports.jsx(Icon, { size: iconSize }) }));
};
EmployeeBadge.displayName = 'EmployeeBadge';

export { EmployeeBadge };
//# sourceMappingURL=EmployeeBadge.js.map
